var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 5.93385C13.3334 6.01269 13.318 6.09077 13.2879 6.16363C13.2578 6.2365 13.2137 6.30273 13.158 6.35852L8.86466 10.6512C8.75216 10.7635 8.59966 10.8267 8.44066 10.8267C8.28166 10.8267 8.12916 10.7635 8.01666 10.6512L3.72332 6.35852C3.61078 6.24572 3.54766 6.09282 3.54785 5.93348C3.54804 5.77414 3.61152 5.6214 3.72432 5.50885C3.83713 5.39631 3.99002 5.3332 4.14936 5.33338C4.30871 5.33357 4.46145 5.39705 4.57399 5.50985L8.44066 9.37652L12.3073 5.50985C12.3912 5.42605 12.4981 5.36899 12.6144 5.34588C12.7307 5.32277 12.8513 5.33466 12.9609 5.38003C13.0704 5.42539 13.1641 5.50222 13.23 5.60079C13.296 5.69936 13.3312 5.81526 13.3313 5.93385L13.3333 5.93385Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.7ef5d042.svg";
export { ForwardRef as ReactComponent };